import { timingSafeEqual } from "crypto";

export default{
    
    data() {
        return{
            Customers:[],
            recordtotal:0,
            pageSize:10,
            pageIndex:1,
            editFormVisible:false,
            editForm:[],
            formLabelWidth: '80px',
            currentRowIndex:-1,
            bIsNew:false,
            listLoading:false,
            sName:'',
            sNameOrder:'',
            sCode:'',
            sCodeOrder:'',
            sDesc:'',
            sDescOrder:'',
        }
    },
    mounted () {
        var me = this;
        this.LoadData();
    },
    methods: {
        LoadData(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = 'customer/getlist';
            this.$axios.get(getMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,
                        'Name':me.sName,
                        'NameOrder':me.sNameOrder,
                        'Code':me.sCode,
                        'CodeOrder':me.sCodeOrder,
                        'Desc':me.sDesc,
                        'DescOrder': me.sDescOrder,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {
                        me.Customers = response.data.DataSource;
                        me.recordtotal = response.data.TotalRecords;
            })
            .catch(function (error) {
                console.log(error)
            });

            this.listLoading = false;
        },
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        handleAdd(){
            this.bIsNew = true;
            this.currentRowIndex = -1;
            this.editFormVisible = true;
            this.editForm = Object.assign({}, {
                    'Id': 0,
                    'Name': '',
                    'Code': '',
                    'Desc':'',
                    'Contact': '',
                    'Tel': '',
                    'Address': '',
                    'CustGuid':'',
                    'bEffect': 'Y',
                    'bEffectType':true
            }); //这句是关键！！！
        },
        handleRefresh()
        {
            this.listLoading = true;
            this.LoadData();
        },
        changeTableSort(column) {
            
             if (column.prop === 'Name') {
                if (column.order === 'descending') {
                    this.sNameOrder = "Desc";
                } else if (column.order === 'ascending') {
                   this.sNameOrder = "Asc";
                }
                this.sCodeOrder = "";
                this.sDescOrder = "";
              } 
              else if (column.prop === 'Code') {
                if (column.order === 'descending') {
                    this.sCodeOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.sCodeOrder = "Asc";
                }
                this.sNameOrder = "";
                this.sDescOrder = "";
              } 
              else if (column.prop === 'Desc') {
                if (column.order === 'descending') {
                    this.sDescOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.sDescOrder = "Asc";
                }
                this.sNameOrder = "";
                this.sCodeOrder = "";
              } 

              this.LoadData();
        },
        handleEdit(index, row) {
            this.bIsNew = false;
            this.currentRowIndex = index;
            this.editFormVisible = true;
            
            this.editForm = Object.assign({}, row); //这句是关键！！！
          },
        //点击关闭dialog
        handleClose(done) {
            /*done();
            location.reload();*/
            this.editFormVisible = false;
        },  
        //点击取消
        handleCancel() {
            this.editFormVisible = false;
        },
        //点击更新
        handleUpdate() { 
            this.editFormVisible = false;

            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            //Save Customer
            var getMethod = 'customer/save';

            var bEffect = "N";
            if(me.editForm.bEffectType)
            {
                bEffect = "Y";
            }
             this.$axios.post(getMethod,
                {
                    'CurrentTokenId': user.TokenId,
                    'CurrentUser': user.LoginName,  
                    'Id': me.editForm.Id,
                    'Name': me.editForm.Name,
                    'Code': me.editForm.Code,
                    'Desc': me.editForm.Desc,
                    'Contact': me.editForm.Contact,
                    'Tel': me.editForm.Tel,
                    'Address': me.editForm.Address,
                    'CustGuid': me.editForm.CustGuid,
                    'bEffect' : bEffect,
                })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        this.$message("保存成功.")

                        var beffective = false;
                        if(response.data.Data.bEffect == "Y")
                        {
                            beffective = true;
                        }

                        if(this.bIsNew)
                        {
                            var newCustomers = [];
                            newCustomers.push( {
                                Id: response.data.Data.Id,
                                Code : me.editForm.Code,
                                Name : me.editForm.Name,
                                Desc : me.editForm.Desc,
                                Contact : me.editForm.Contact,
                                Tel : me.editForm.Tel,
                                Address : me.editForm.Address,
                                CustGuid : response.data.Data.CustGuid,
                                bEffect :  response.data.Data.bEffect,
                                bEffectType :  beffective
                                }
                            );
                            me.Customers.forEach(element => {
                                newCustomers.push(element);
                            });
                            if(me.recordtotal>me.pageSize)
                            {
                                newCustomers.pop();
                            }

                            me.Customers = newCustomers;
                            me.recordtotal += 1;
                            
                            
                        }
                        else{
                            me.$set(me.Customers,me.currentRowIndex,{
                                Id: response.data.Data.Id,
                                Code : me.editForm.Code,
                                Name : me.editForm.Name,
                                Desc : me.editForm.Desc,
                                Contact : me.editForm.Contact,
                                Tel : me.editForm.Tel,
                                Address : me.editForm.Address,
                                CustGuid : response.data.Data.CustGuid,
                                bEffect :  response.data.Data.bEffect,
                                bEffectType :  beffective
                            });
                        }
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
            })
            .catch(function (error) {
                this.alert(error);
            }); 
        },

          handleDelete(index, row) {
            this.$confirm('此操作将永久删除该客户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                var me = this;
                    var user = sessionStorage.getItem('user');
                    if (user) {
                        user = JSON.parse(user);
                    }
                    var Method = 'customer/delete/'+user.TokenId+"/"+user.LoginName+"/"+ row.Id;
                    this.$axios.post(Method)
                    .then((response) => {
                            if(response.data.IsSuccess)
                            {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            
                                var newCustomers = [];
                                    
                                me.Customers.forEach(element => {
                                    if(element.Id!=row.Id)
                                        newCustomers.push(element);
                                    });

                                me.Customers = newCustomers;
                                me.recordtotal -= 1;
                            }
                            else
                            {
                                var strMsg = '';
                                response.data.Messages.forEach(element => {
                                    strMsg += element.Message +'\r\n';
                                });
                                
                                this.alert(strMsg);
                            }
                        
                    })
                    .catch(function (error) {
                        this.alert(error);
                    }); 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
          },
          
    }

}


// WEBPACK FOOTER //
// ./src/components/MaintainCustomer/MaintainCustomer.js